import { ForwardedRef, forwardRef, useState } from 'react'

import styles from '~/shared/styles/Input.module.css'

import { FieldError } from './FieldError'

export interface ErrorMessage {
  message: string
}

interface Props<T> {
  autoComplete: string
  disabled?: boolean
  fieldErrors?: string | false
  className?: string
  labelClassName?: string
  inputClassName?: string
  label: string
  name: string
  setValue: (val: T, name: string) => void
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  type: string
  value: string
  isCaptchaInput?: boolean
  onBlur?: () => void
  onFocus?: () => void
  spellCheck?: boolean
}

export const InputV2 = forwardRef(function Input<T extends string>(
  props: Props<T>,
  ref?: ForwardedRef<HTMLInputElement>,
): React.ReactElement {
  const {
    autoComplete,
    disabled,
    fieldErrors,
    className,
    labelClassName,
    inputClassName,
    label,
    name,
    setValue,
    type,
    value,
    onClick,
    isCaptchaInput,
    onBlur,
    onFocus,
    spellCheck,
  } = props

  const [focused, setFocused] = useState(false)

  const handleOnBlur = (): void => {
    setFocused(false)
    if (onBlur) onBlur()
  }

  const handleOnFocus = (): void => {
    setFocused(true)
    if (onFocus) onFocus()
  }
  // type guarding
  const isStringFieldError = typeof fieldErrors === 'string' && fieldErrors.length

  return (
    <div className={`${styles['form-input-wrapper']} ${isCaptchaInput ? 'flex' : ''} `}>
      <div
        className={`${styles['form-input-container']} ${isStringFieldError ? `${styles['error']}` : ''} ${className}`}
      >
        <input
          autoComplete={autoComplete}
          className={`${styles['form-input']} ${value ? `${styles['--has-value']}` : ''} ${inputClassName ?? ''}`}
          disabled={disabled}
          id={name}
          name={name}
          onBlur={handleOnBlur}
          onChange={(e) => setValue(e.target.value as T, name)}
          onClick={onClick}
          onFocus={handleOnFocus}
          placeholder={(focused && !value) || isStringFieldError ? label : ''}
          ref={ref}
          spellCheck={spellCheck}
          type={type}
          value={value}
        />

        <label
          className={`${styles['form-input-label']} ${value ? `${styles['--has-value']}` : ''} ${labelClassName ?? ''}`}
          htmlFor={name}
        >
          {label}
        </label>
      </div>
      <FieldError error={isStringFieldError ? fieldErrors : undefined} />
    </div>
  )
})
